import { GzIntegrityMonitorRealTimeWebComponent } from './component/GzIntegrityMonitorRealTimeWebComponent';

export { GzIntegrityMonitorRealTimeWebComponent };
